import CookiesJS from 'cookies-js';

export function initVideoUpload($, filesClient) {
    $('body').on('change', '.upload-video__input-files', async function () {
        try {
            const files = $(this).prop('files');
            $(this).parent().find('.preloader .bar').show();
            const {uploadedFiles} = await filesClient.uploadStatic(files, CookiesJS.get('auth_token'));
            $(this).parent().find('input[type="text"]').val(uploadedFiles[0].location);
            feather.replace();
        } catch(e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
        $(this).parent().find('.preloader .bar').hide();
        // $(this).reset(); // TODO: fix me
    });
}
